import React from "react";
import {connect} from "react-redux";
import {modalActions} from "../actions/modal.actions";
import {claimTypes} from "../constants/claim.constants";
import SubstringWithDot from "./SubstringWithDot";

const DeviceInfoColumn = ({user, networkDevice, hideModal, showModal}) => {
    const claimAccess = user[`c_network-device`] || null;

    const onClickLabel = (networkDeviceModel, event) => {
        event.preventDefault();
        showModal({
            open: true,
            large: true,
            title: 'Device info',
            networkDeviceModel: networkDeviceModel,
            closeModal: closeModal
        }, 'deviceInfo')
    };

    const closeModal = () => {
        hideModal()
    };

    return (
        <div>
            { claimAccess === claimTypes.NONE ? (
                <React.Fragment>
                    <h6><SubstringWithDot classNames="desc ws-n" stringData={networkDevice?.label} numberChar={15} /></h6>
                    <p>{networkDevice?.ipAddress} | {networkDevice?.port}</p>
                </React.Fragment>
            ) : (
                <React.Fragment>
                    <h6>
                        <span className="custom-link" onClick={(event) => onClickLabel(networkDevice, event)}>
                            <SubstringWithDot classNames="desc ws-n" stringData={networkDevice?.label} numberChar={15} />
                        </span>
                    </h6>
                    <p>{networkDevice?.ipAddress} | {networkDevice?.port}</p>
                </React.Fragment>
            ) }

        </div>
    )
};

const mapStateToProps = state => {
    const { user } = state.authenticationReducer;
    return {
        user
    }
};

const mapDispatchToProps = dispatch => ({
    hideModal: () => dispatch(modalActions.hideModal()),
    showModal: (modalProps, modalType) => {
        dispatch(modalActions.showModal({ modalProps, modalType }))
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(DeviceInfoColumn);
